import { useEffect, useState } from 'react';
import { useLogMarketAnalyticsEvent } from './useLogMarketAnalyticsEvent';

export const useLogViewFavoriteRecommendedMarketModal = (count: number) => {
  const [isLogged, setIsLogged] = useState(false);
  const logMarketAnalytics = useLogMarketAnalyticsEvent();

  useEffect(() => {
    if (isLogged) return;

    logMarketAnalytics({
      name: 'VIEW_FAVORITE_RECOMMENDED_MARKET_MODAL',
      analytics: {
        RECOMMENDED_MARKET_COUNT: count,
      },
    });
    setIsLogged(true);
  }, [count, isLogged, logMarketAnalytics]);
};
